import { render, staticRenderFns } from "./DropdownTabContent.ts.vue?vue&type=template&id=28afba4a"
import script from "./DropdownTabContent.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownTabContent.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DropdownTabContent.ts.vue?vue&type=style&index=0&id=28afba4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports